import { produce } from 'immer';
import { ALL_ROOM_SCENE_TYPES } from '../../types/commonTypes';
import { SET_SCENE } from '../actions/sceneActions';
export const DEFAULT_SCENE_TYPE = 'entry';
const initialState = {
    sceneType: DEFAULT_SCENE_TYPE
};
const sceneReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_SCENE: {
                const sceneType = action.payload;
                draft.sceneType = sceneType;
                if (ALL_ROOM_SCENE_TYPES.includes(sceneType)) {
                    draft.roomSceneType = sceneType;
                }
                else {
                    delete draft.roomSceneType;
                }
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default sceneReducer;
